import { combineReducers } from "@reduxjs/toolkit";
import authReducer from 'src/store/feature/auth/authSlice';
import dashboardReducer from 'src/store/feature/dashboard/dashboardSlice';
import moduleReducer from 'src/store/feature/module/moduleSlice';
import notificationsReducer from "src/store/feature/notification/notificationSlice";
import uiReducer from "src/store/feature/ui/uiSlice";
import projectReducer from "src/store/feature/project/projectSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  module: moduleReducer,
  notification: notificationsReducer,
  ui: uiReducer,
  project: projectReducer,
})

export default rootReducer
